import gql from 'graphql-tag'

export const GET_PRODUCT_REVIEW = gql`
  query getProductByUrlKeyForDetailReviews($url: String!) {
    productReview: getProductByUrlKey(urlKey: $url) {
      id
      review {
        reviews {
          user
          rank
          message
          source
          showAuthor
          createdAt
          pros
          cons
        }
        stats {
          ranksCount
          averageRank
          messagesCount
          stars {
            rank
            ranksCount
            messagesCount
            rankPercentile
            rankPercent
          }
        }
      }
    }
  }
`
